<template>
  <div>
    <ImageUpload />
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import ImageUpload from "@/components/ImageUpload.vue";

export default {
  components: {
    // HelloWorld
    ImageUpload
  }
};
</script>
